import { useTranslation } from 'react-i18next';

import { SuggestionChangesNavigation } from '../SuggestionChangesNavigation/SuggestionChangesNavigation';

type SuggestionChangesBannerProps = {
  numberOfChanges: number;
};

export const SuggestionChangesBanner = ({ numberOfChanges }: SuggestionChangesBannerProps) => {
  const { t } = useTranslation();

  if (numberOfChanges === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-3 bg-gray-50 px-6 py-3">
      <p className="flex-1 text-sm leading-5 text-gray-900">{t('webedi:suggestionModal.changesBanner.description')}</p>
      <SuggestionChangesNavigation numberOfChanges={numberOfChanges} />
    </div>
  );
};
